define('SearchFieldObservable',[], function () {
    /**
     * @class     
     * @param {HTMLInputElement} inputElement Input element to make observable
     */
    function SearchFieldObservable(inputElement) {
        /**
         * @property {Observer[]} _observers subscribed observers
         */
        this._observers = [];

        /**
         * @property {HTMLInputElement} field Field to observe
         */
        this.field = inputElement;

        /**
         * @property {Number} _debounceTimer Debounce Timeout
         */
        this._debounceTimer = null;

        this._lastValue = this.field.value;

        this._initDomEvents(); //  Init DOM events
    }

    SearchFieldObservable.prototype._fieldChangeHandler = function (event) {
        if (event.key) {
            var code = event.key.toLowerCase();
            if (code.indexOf("down") > -1 &&
                code.indexOf("up") > -1 &&
                code.indexOf("enter") > -1 &&
                code.indexOf("right") > -1
            ) return;
        }        
        if (this._lastValue !== this.field.value) {
            this._lastValue = this.field.value;
            this.notify();
        }        
    };

    /**
     * Initializes the DOM events
     * @method
     */
    SearchFieldObservable.prototype._initDomEvents = function () {
        this.field.addEventListener("change", this._fieldChangeHandler.bind(this));
        this.field.addEventListener("keyup", this._fieldChangeHandler.bind(this));
        this.field.addEventListener("click", this._fieldChangeHandler.bind(this));
        this.field.addEventListener("touchend", this._fieldChangeHandler.bind(this));      
        this.field.addEventListener("search", this._fieldChangeHandler.bind(this));
    };

    /**
     * Debounces the notify calls and notifies the observable observers
     * @method
     */
    SearchFieldObservable.prototype.notify = function () {
        clearTimeout(this._debounceTimer);
        this._debounceTimer = setTimeout((function () {
                this.notify();
            }).bind(this),
        50);
    };

    SearchFieldObservable.prototype.add = function(observer) {
        this._observers.push(observer);
    };
    SearchFieldObservable.prototype.notify = function() {
        this._observers.forEach(function(o) {
            o.update();
        });
    };

    return SearchFieldObservable;
});
/**
 * Made with ♥ by NewHomeSource's team
 * Copyright (c) 2019-present, BuilderHomeSite Inc. All rights reserved.
 */;
